<head>

<script src="https://unpkg.com/vue"></script>
<script src="https://unpkg.com/vue-cal"></script>
<link href="https://unpkg.com/vue-cal/dist/vuecal.css" rel="stylesheet">
</head>
<template>
  <a-card title="Listar Horário de Atendimento">
    <div class="row">
      <div class="col-md-10">
        <label for="nome">Departamento</label>
        <br />
        <div class="input-group input-focus">
          <a-auto-complete v-model:value="objPesquisa.departamento.nome" style="width: 200px" @search="pesquisarDepartamentos" class="form-control border-left-0">
            <template v-slot:dataSource>
              <a-select-option v-for="item in departamentos" :key="item.nome" @click="onSelect(item)">
                {{ item.nome }}
              </a-select-option>
            </template>
          </a-auto-complete>
        </div>
      </div>
    </div>
    <a-divider type="horizontal" />
    <div class="row">
      <div class="col-md-4" style="margin-bottom: 0.3%">
        <button @click="pesquisar()" class="btn btn-primary" type="button"><i class="fa fa-search"> </i> Pesquisar</button>
        <button type="button" class="btn btn-primary" @click="criarNova" style="margin: 0 5px"><i class="fa fa-plus"> </i> Criar novo</button>
      </div>
    </div>
  </a-card>
  <br />
  <a-card>
    <a-table :dataSource="lista" :columns="columns" :pagination="paginationConfig">
      <template #action="{ record }">
        <a @click="visualizar(record)">
          <i class="fas fa-eye icon-trash"></i>
        </a>
        &nbsp;&nbsp;
        <a title="Excluir" @click="excluir(record)"><i class="fas fa-trash icon-trash"></i></a>
        &nbsp;&nbsp;
        <a title="Editar" @click="editar(record)"><i class="fas fa-edit icon-edit"></i></a>
      </template>
    </a-table>
  </a-card>
  <Dialog header="Detalhes Horário de Atendimento" v-model:visible="showDialog" id="showDialog">
    <div class="row">
      <div>
        <a-table :dataSource="horarioAtendimentoSelecionado.periodosAtendimento" :columns="columnsSubTable" :key="horarioAtendimentoSelecionado.id"> </a-table>
      </div>
    </div>
  </Dialog>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { deleteById, getLista } from '@/components/service/horarioAtendimentoService';
import { getListaDepartamento } from '@/components/service/departamentoService';
export default {
  name: 'PageListarHorarioAtendimento',
  data() {
    return {
      situacao: 'TODOS',
      nome: undefined,
      horarioAtendimentoSelecionado: undefined,
      objPesquisa: { departamento: { id: null, nome: null } },
      lista: [],
      showDialog: false,
      paginationConfig: {
        pageSize: 10, // Define o número de itens por página
        total: 0, // Total de itens no dataSource
      },
      columns: [
        {
          title: 'Departamento',
          dataIndex: 'departamento.nome',
          key: 'departamento.nome',
          slots: { customRender: 'departamento.nome' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
      columnsSubTable: [
        {
          title: 'DIA',
          dataIndex: 'diaSemana',
          key: 'diaSemana',
        },
        {
          title: 'Qtde. Atendimentos',
          dataIndex: 'quantidade',
          key: 'quantidade',
          slots: { customRender: 'quantidade' },
        },
        {
          title: 'Horário Inicial',
          dataIndex: 'horaInicio',
          key: 'horaInicio',
          slots: { customRender: 'horaInicio' },
        },
        {
          title: 'Horário Final',
          dataIndex: 'horaFim',
          key: 'horaFim',
          slots: { customRender: 'horaFim' },
        },
      ],
    };
  },
  methods: {
    excluir(record) {
      deleteById(record.id)
        .then(() => {
          openNotification(typesNotification.success, 'Horário de atendimento excluído com sucesso.');
          this.pesquisar();
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao excluir Horário de atendimento!');
        });
    },
    editar(record) {
      this.$router.push({ path: '/form-horario-atendimento', query: { id: record.id } });
    },
    visualizar(record) {
      this.horarioAtendimentoSelecionado = record;
      this.showDialog = true;
    },
    criarNova() {
      this.$router.push('form-horario-atendimento');
    },
    async pesquisarDepartamentos(value) {
      if (value.length >= 2) {
        let filtros = { situacao: 'ATIVO', nome: value };
        await getListaDepartamento(filtros).then((response) => {
          this.departamentos = response.data;
        });
      }
    },
    onSelect(value) {
      this.objPesquisa.departamento = { id: value.id, nome: value.nome };
    },
    async pesquisar() {
      getLista(this.objPesquisa)
        .then((r) => {
          if (r.data.length > 0) {
            this.lista = r.data;
          } else {
            openNotification(typesNotification.info, 'Nenhum registro encontrado para os dados informados na pesquisa!');
            this.lista = r.data;
          }
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao recuperar a lista de horários de atendimentos cadastrados!');
        });
    },
  },
  created() {
    this.pesquisar();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}
</style>
